import React from 'react';
import '../../../../styles/welcome.scss';


const Image = (props) => (
    <img {...props} src={props.image} alt='' />
);

export default Image;